// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import Button from './button';
import Icon from './icon';
import OverlayTrigger from './overlay-trigger';

// Styles
import './dropdown.scss';

export default class Dropdown extends Component {
    getProps() {
        const {dropdownRenderer, className} = this.props;

        return {
            className: classnames('dropdown', className),
            overlayRenderer: dropdownRenderer,
            triggerType: 'click',
        };
    }

    getButtonProps() {
        const {buttonClassName, type} = this.props;

        return {
            className: classnames(buttonClassName, 'dropdown--button'),
            dropdown: true,
            type,
        };
    }

    render() {
        const {children} = this.props;

        return (
            <OverlayTrigger {...this.getProps()}>
                <Button {...this.getButtonProps()}>
                    {children} <Icon fontAwesomeType="caret-down" />
                </Button>
            </OverlayTrigger>
        );
    }
}

Dropdown.propTypes = {
    buttonClassName: PropTypes.string,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    dropdownRenderer: PropTypes.func.isRequired,
    type: PropTypes.string,
};
